"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Overlay_1 = require("../../utils/Overlay");
var ChromeTooltipUtility_1 = require("./ChromeTooltipUtility");
var ChromeTooltipBox_1 = require("./ChromeTooltipBox");
var ChromeTooltipArrow_1 = require("./ChromeTooltipArrow");
function ChromeTooltipDisplay(props) {
    var getAnchorClientRect = function () {
        var rect = props.targetElement.getBoundingClientRect();
        var y = getTopFromOverlaidPosition(props.side, props.offset);
        var x = getLeftFromOverlaidPosition(props.side, props.offset);
        return {
            top: rect.top + y,
            bottom: rect.bottom + y,
            left: rect.left + x,
            right: rect.right + x,
        };
    };
    return (React.createElement(Overlay_1.Overlay, { getAnchorClientRect: getAnchorClientRect, zIndex: props.zIndex, anchorOrigin: getAnchorOrigin(props.side), stackedOrigin: getStackedOrigin(props.side) },
        React.createElement("div", { ref: props.handleRef, onMouseLeave: props.close },
            React.createElement("div", { style: getContainerStyle(props.positioned, props.side) },
                React.createElement(ChromeTooltipBox_1.ChromeTooltipBox, { content: props.content, width: props.width }),
                React.createElement(ChromeTooltipArrow_1.ChromeTooltipArrow, { direction: getDirection(props.side), style: getArrowStyle(props.side, props.offset) })))));
}
exports.ChromeTooltipDisplay = ChromeTooltipDisplay;
function getAnchorOrigin(side) {
    switch (side) {
        case 'Top': return { horizontal: Overlay_1.HorizontalOriginOption.centerX, vertical: Overlay_1.VerticalOriginOption.top };
        case 'Bottom': return { horizontal: Overlay_1.HorizontalOriginOption.centerX, vertical: Overlay_1.VerticalOriginOption.bottom };
        case 'Left': return { horizontal: Overlay_1.HorizontalOriginOption.left, vertical: Overlay_1.VerticalOriginOption.centerY };
        case 'Right': return { horizontal: Overlay_1.HorizontalOriginOption.right, vertical: Overlay_1.VerticalOriginOption.centerY };
        default: return ChromeTooltipUtility_1.assertNever(side);
    }
}
function getStackedOrigin(side) {
    switch (side) {
        case 'Top': return { horizontal: Overlay_1.HorizontalOriginOption.left, vertical: Overlay_1.VerticalOriginOption.bottom };
        case 'Bottom': return { horizontal: Overlay_1.HorizontalOriginOption.left, vertical: Overlay_1.VerticalOriginOption.top };
        case 'Left': return { horizontal: Overlay_1.HorizontalOriginOption.right, vertical: Overlay_1.VerticalOriginOption.top };
        case 'Right': return { horizontal: Overlay_1.HorizontalOriginOption.left, vertical: Overlay_1.VerticalOriginOption.top };
        default: return ChromeTooltipUtility_1.assertNever(side);
    }
}
function getTopFromOverlaidPosition(side, offset) {
    return ChromeTooltipUtility_1.isHorizontalSide(side) ? -1 * offset : 0;
}
function getLeftFromOverlaidPosition(side, offset) {
    return ChromeTooltipUtility_1.isVerticalSide(side) ? -1 * offset : 0;
}
function getContainerStyle(positioned, side) {
    return {
        visibility: positioned ? 'visible' : 'hidden',
        display: 'flex',
        flexDirection: getFlexDirection(side),
        flexWrap: 'nowrap',
        justifyContent: 'flex-start',
        alignItems: 'center'
    };
}
function getFlexDirection(side) {
    switch (side) {
        case 'Top': return 'column';
        case 'Bottom': return 'column-reverse';
        case 'Left': return 'row';
        case 'Right': return 'row-reverse';
        default: return ChromeTooltipUtility_1.assertNever(side);
    }
}
function getDirection(side) {
    switch (side) {
        case 'Top': return 'Down';
        case 'Bottom': return 'Up';
        case 'Left': return 'Right';
        case 'Right': return 'Left';
        default: return ChromeTooltipUtility_1.assertNever(side);
    }
}
function getArrowStyle(side, offset) {
    var mainAxisOffset = -1.2;
    var crossAxisOffset = offset - ChromeTooltipArrow_1.Height / 2;
    var style = { alignSelf: 'flex-start' };
    switch (side) {
        case 'Top':
            style.marginTop = mainAxisOffset;
            style.marginLeft = crossAxisOffset;
            break;
        case 'Bottom':
            style.marginBottom = mainAxisOffset;
            style.marginLeft = crossAxisOffset;
            break;
        case 'Left':
            style.marginLeft = mainAxisOffset;
            style.marginTop = crossAxisOffset;
            break;
        case 'Right':
            style.marginRight = mainAxisOffset;
            style.marginTop = crossAxisOffset;
            break;
        default:
            ChromeTooltipUtility_1.assertNever(side);
    }
    return style;
}
//# sourceMappingURL=ChromeTooltipDisplay.js.map